module.exports = __webpack_public_path__ + "449cd34fba56a15b727ca12917572dab.ttf";